import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IUsers } from "./routeType";
import { useGetAllUser } from "./getAll";
import { useGetUser } from "./get";

const { getPath } = getApi("users.delete");

type IExtractedRouteType = IUsers["userSingleDelete"];

export type IDeleteUsers = IPickDelete<IExtractedRouteType>;

const deleteUser: MutationFunction<
  IDeleteUsers["response"],
  IDeleteUsers["variables"]
> = ({ userId, ...params }) => {
  return axiosClient.delete(getPath({ userId }), { params });
};

export const useDeleteUser = createMutation({
  mutationFn: deleteUser,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetUser.getKey({ userId }) });
  },
});
